import { EditorView } from "@codemirror/view";

// Focus at a specific position in the editor when the editor is mounted

export function createFocusAtPositionHandler(focusAtPosition: number | null) {
  if (focusAtPosition === null) return null;
  let isFocused = false;

  return EditorView.updateListener.of(update => {
    if (isFocused) return;
    isFocused = true;

    const view = update.view;
    if (view) {
      // Ensure the position is within bounds
      const maxPosition = update.state.doc.length;
      const safePosition = Math.min(focusAtPosition, maxPosition);

      // Set cursor position and focus
      view.dispatch({
        selection: { anchor: safePosition, head: safePosition },
        scrollIntoView: true
      });

      // Focus the editor
      view.focus();
    }
  });
}
